import markdownit from 'markdown-it/lib';

export const markDownToHtml = (markDownText : string) => {
    return markdownit().render(markDownText);
}